const TrashIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="22"
      viewBox="0 0 20 22"
      className="shake-trash-icon"
    >
      <path
        id="Form_43"
        data-name="Form 43"
        d="M1411,488a3,3,0,0,1-3-3V472h-1a1,1,0,0,1,0-2h4v-1a3,3,0,0,1,3-3h4a3,3,0,0,1,3,3v1h4a1,1,0,0,1,0,2h-1v13a3,3,0,0,1-3,3Zm-1-3a1,1,0,0,0,1,1h10a1,1,0,0,0,1-1V472h-12Zm9-15v-1a1,1,0,0,0-1-1h-4a1,1,0,0,0-1,1v1Zm-2,12v-6a1,1,0,0,1,2,0v6a1,1,0,0,1-2,0Zm-4,0v-6a1,1,0,0,1,2,0v6a1,1,0,0,1-2,0Z"
        transform="translate(-1406 -466)"
        fill="white"
      />
    </svg>
  );
};

export default TrashIcon;
